import { useState } from 'react';

type Theme = 'light' | 'dark';

const setHtmlTheme = (theme: Theme) => {
  const html = document.documentElement;
  html.classList.remove('light', 'dark');
  html.classList.add(theme);
};

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>('light');

  return {
    theme,
    updateTheme: (newTheme: Theme) => {
      setTheme(newTheme);
      setHtmlTheme(newTheme);
    },
  };
};
